import React from 'react'
import { IProps, IFeatureTooltipItem } from './index'
import { Tooltip } from '../../elements/Tooltip'
import classnames from 'classnames'
import { Text } from '../../elements/Text'

// REFACTOR
// Similar to the Tooltip element, could benefit from extracting this out
// And instead exporting that here
const FeatureTooltipItem = (item: IFeatureTooltipItem) => {
  return (
    <span
      data-testid="feature-tooltip-item"
      className={classnames('content', { 'with-icon': item.icon })}
    >
      <div className="icon-container">
        {item.icon && <img className="icon" src={item.icon} alt={item.text} />}
      </div>
      <Text brand="default" size="eyebrows">
        {item.text}
      </Text>
      <style jsx>{`
        .content {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
        }

        .content.with-icon {
          white-space: nowrap;
        }

        .icon {
          width: inherit;
          max-width: inherit;
          height: auto;
        }

        .icon-container {
          width: 22px;
          display: flex;
          align-items: center;
          margin-right: 12px;
        }
      `}</style>
    </span>
  )
}

const FeatureTooltipItemsWrapper = ({ items }: { items: IProps['items'] }) => {
  return (
    <div>
      {items?.map((item) => (
        <FeatureTooltipItem key={item.text} {...item} />
      ))}
    </div>
  )
}

export const FeatureTooltip: React.FC<IProps> = (props) => {
  // Text is used in the aria label so it's also important to include it
  const ariaLabel = props.items?.map(({ text }) => text).join(' ')
  return (
    <Tooltip
      eyebrow={props.title}
      above={props.above}
      text={ariaLabel}
      content={<FeatureTooltipItemsWrapper items={props.items} />}
    >
      {props.children}
    </Tooltip>
  )
}
